import { specifiedPoolApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SPECIFIED_POOLS_ACTION_TYPE = createNamedActions('specifiedPools', {
  GET_SPECIFIED_POOLS: 'GET_SPECIFIED_POOLS',
  CREATE_SPECIFIED_POOL: 'CREATE_SPECIFIED_POOL',
  UPDATE_SPECIFIED_POOL: 'UPDATE_SPECIFIED_POOL',
  CLONE_SPECIFIED_POOL: 'CLONE_SPECIFIED_POOL',
});

export const getSpecifiedPoolsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await specifiedPoolApi.getSpecifiedPools(params);

  return dispatch({
    type: SPECIFIED_POOLS_ACTION_TYPE.GET_SPECIFIED_POOLS,
    payload: data,
  });
});

export const createSpecifiedPoolAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await specifiedPoolApi.createSpecifiedPool(body);

  return dispatch({
    type: SPECIFIED_POOLS_ACTION_TYPE.CREATE_SPECIFIED_POOL,
    payload: data,
  });
});

export const updateSpecifiedPoolAction = catchAsyncActionError(
  ({ id, ...body }) =>
    async dispatch => {
      const { data } = await specifiedPoolApi.updateSpecifiedPool(id, body);

      return dispatch({
        type: SPECIFIED_POOLS_ACTION_TYPE.UPDATE_SPECIFIED_POOL,
        payload: data,
      });
    },
);

export const cloneSpecifiedPoolAction = catchAsyncActionError(
  ({ id, ...body }) =>
    async dispatch => {
      const { data } = await specifiedPoolApi.cloneSpecifiedPool(id, body);

      return dispatch({
        type: SPECIFIED_POOLS_ACTION_TYPE.CLONE_SPECIFIED_POOL,
        payload: data,
      });
    },
);
